<mat-card appearance="outlined">
  <mat-card-title>Réinitialiser votre mot de passe</mat-card-title>
  <form [formGroup]="form">
    @if (step === 1) {
      <div>
        @if (!isLoading) {
          <div>
            <mat-form-field>
              <mat-label>Email</mat-label>
              <input [(ngModel)]="login.username" formControlName="email" matInput>
              @if (form.get('email').hasError('required')) {
                <mat-error>
                  L'email est requis
                </mat-error>
              }
              @if (form.get('email').hasError('email')) {
                <mat-error>
                  L'email doit être valide
                </mat-error>
              }
            </mat-form-field>
            <p class="space_button">
              <button mat-button (click)="sendResetPassword()" [disabled]="form.get('email').errors">Valider</button>
            </p>
          </div>
        }
      </div>
    }
    @if (step === 2) {
      <div>
        @if (!isLoading) {
          <div>
            <p class="left-text">Votre email est reconnu. Un code de confirmation vous a été envoyé. Veuillez le saisir ci-dessous</p>
            <mat-form-field>
              <mat-label>Code de confirmation</mat-label>
              <input [(ngModel)]="login.activationCode" formControlName="confirmationCode" matInput>
              @if (form.get('confirmationCode').hasError('required')) {
                <mat-error>
                  Le code de confirmation est requis
                </mat-error>
              }
              @if (form.get('confirmationCode').hasError('minlength') || form.get('confirmationCode').hasError('maxlength')) {
                <mat-error>
                  Le code de confirmation doit faire 6 caractères
                </mat-error>
              }
            </mat-form-field>
            <p>
              <button mat-button (click)="validConfirmationCode()" [disabled]="form.get('confirmationCode').errors">Valider</button>
            </p>
          </div>
        }
      </div>
    }
    @if (step === 3) {
      <div>
        <p class="left-text">Merci de remplir les champs suivants pour remplacer votre mot de passe</p>
        <mat-form-field>
          <mat-label>Nouveau mot de passe</mat-label>
          <input [(ngModel)]="login.password" matInput formControlName="password" type="password">
          @if (form.get('password').hasError('required')) {
            <mat-error>
              Le mot de passe est requis
            </mat-error>
          }
          @if (form.get('password').hasError('minlength')) {
            <mat-error>
              Le mot de passe doit faire au minimum 8 caractères
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Confirmation de votre nouveau mot de passe</mat-label>
          <input formControlName="passwordConfirm" matInput type="password">
          @if (form.get('passwordConfirm').hasError('required')) {
            <mat-error>
              La confirmation de mot de passe est requise
            </mat-error>
          }
          @if (form.get('passwordConfirm').hasError('mismatch')) {
            <mat-error>
              Les 2 mots de passes ne correspondent pas
            </mat-error>
          }
        </mat-form-field>
        <p>
          <button (click)="changePassword()"
            [disabled]="form.get('password').errors || form.get('passwordConfirm').errors" mat-button>Changer mon
            mot de passe
          </button>
        </p>
      </div>
    }
    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    }
  </form>
</mat-card>
<div class="link_resend">
  @if (!isLoading && step === 2) {
    <button mat-button (click)="resendConfirmationCode()">Nouveau code par email</button>
  }
</div>
